/**
 * @file Links payments to a charge through `charge/:id/link` and confirms it in a snackbar.
 * A refusal the charge-link route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  be_ajv_not_validated: null,
  financial_operations_were_blocked: { titleKey: "refusal-title-link", bodyKey: "refusal-body-financial-processing-busy" },
  be_dynamic_error: { titleKey: "refusal-title-link", bodyKey: "refusal-body-link-charge-unavailable" },
  be_unauthorized: { titleKey: "refusal-title-link", bodyKey: "refusal-body-link-payment-unavailable" },
  cannot_link_payment_paid_directly_to_owner_charge: { titleKey: "refusal-title-link", bodyKey: "refusal-body-link-direct-payment" },
  cannot_mix_payment_routes: { titleKey: "refusal-title-link", bodyKey: "refusal-body-mixed-payment-routes" },
  cannot_pay_charge_with_different_type_of_payment: { titleKey: "refusal-title-link", bodyKey: "refusal-body-payment-type-mismatch" },
  cannot_pay_charge_with_type_of_currency_different_from_payment: { titleKey: "refusal-title-link", bodyKey: "refusal-body-currency-mismatch" },
  charge_already_is_fully_paid: { titleKey: "refusal-title-link", bodyKey: "refusal-body-charge-fully-paid" }
};

export default function* chargeLink(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_LINK_REQUEST
    });

    yield call(Http.put, `charge/${action.payload?.charge?.id}/link`, {
      paymentIds: action.payload?.paymentIds
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_LINK_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-linked-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_CHARGE_LINK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeLink() {
  yield takeEvery(Constants.GLOBAL_CHARGE_LINK_START, chargeLink);
}
